import {combineReducers} from 'redux'
import {routerReducer} from 'react-router-redux'
import {reducer as burgerMenu} from 'redux-burger-menu'
import responseStatus from './common/redux/reducers.responseStatus'
import auth from './auth/redux/reducers'
import forgotPw from './auth/redux/reducers.forgotPw'
import profile from './profile/redux/reducers'
import publicProfile from './publicUser/redux/reducers'
import notifications from './common/redux/reducers.notifications'
import signup from './auth/redux/reducers.signup'
import campaign from './campaign/redux/reducers'
import demo from './demo/redux/reducers'

const rootReducer = combineReducers({
  routing: routerReducer,
  responseStatus,
  auth,
  forgotPw,
  profile,
  notifications,
  signup,
  campaign,
  publicProfile,
  burgerMenu,
  demo,
})

export default rootReducer
